import { VChip } from 'vuetify/lib/components/VChip';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VChip,_vm._b({attrs:{"color":_vm.color,"label":"","small":"","dark":""}},'v-chip',_vm.$attrs,false),[_vm._t("default",function(){return [_c('span',{staticClass:"uppercase-first-letter"},[_vm._v(_vm._s(_vm.$t(_vm.formatCodeToHumanText(_vm.value))))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }